export type Buyer = { name: string; country: string; flag: string };

export const buyers: Buyer[] = [
  { name: "María González", country: "Mexico", flag: "🇲🇽" },
  { name: "Valentina Rojas", country: "Colombia", flag: "🇨🇴" },
  { name: "Lucía Fernández", country: "Argentina", flag: "🇦🇷" },
  { name: "Carmen Ruiz", country: "Spain", flag: "🇪🇸" },
  { name: "Rosa Quispe", country: "Peru", flag: "🇵🇪" },
  { name: "Camila Soto", country: "Chile", flag: "🇨🇱" },
  { name: "Andrea Vélez", country: "Ecuador", flag: "🇪🇨" },
  { name: "Gabriela Morales", country: "Guatemala", flag: "🇬🇹" },
  { name: "Daniela Jiménez", country: "Costa Rica", flag: "🇨🇷" },
  { name: "Isabel Peña", country: "Dominican Republic", flag: "🇩🇴" },
  { name: "Sofía Pereira", country: "Uruguay", flag: "🇺🇾" },
  { name: "Mariana Castillo", country: "Venezuela", flag: "🇻🇪" },
  { name: "Ana Rivera", country: "Puerto Rico", flag: "🇵🇷" },
  { name: "Paola Mendoza", country: "Bolivia", flag: "🇧🇴" },
  { name: "Elena Herrera", country: "Panama", flag: "🇵🇦" },
  { name: "Natalia Benítez", country: "Paraguay", flag: "🇵🇾" },
];
